import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  //endpoint = 'https://web.oncore.com.my/WebSite/WebSite.svc/';
  //iconbase = 'https://web.oncore.com.my/WebSite/Mob';
  baseendpoint = 'https://oncore.com.my/#/';
  endpoint = 'https://oncore.com.my/WebSite/WebSite.svc/';
  iconbase = 'https://oncore.com.my/WebSite/Mob';
  // plateNoUrl = "http://rtsclient.com/website/website.svc/GetMobile/";
  plateNoUrl = "https://oncore.com.my/website/website.svc/GetMobile/";
  
  httpOptions = {
   headers: new HttpHeaders({
    'Content-Type':  'application/json'
   })
  };
  
  constructor(private router: Router) { }
  
  getEndpointUrl(){
	return this.endpoint;
  }
  
  getHttpHeader(){
	return this.httpOptions;
  }
  
  getIconbase(){
	return this.iconbase;
  }

  getPlateEndpointUrl(){
	return this.plateNoUrl;
  }
  
  /**
   * navigation from 1 page to another
   * @param path that set in app-routing.module.ts
   */
  navigateInternal(path){
	this.router.navigateByUrl(path);
  }
  
  wsr2obj(results) {
		let obj = {};
		results.forEach((data) => {
			let oriKey = data.Key;
			let key = oriKey.toLowerCase();
			if (data.Value.indexOf && data.Value.indexOf('/Date(') == 0) {
				data.Value = moment(data.Value.substr(6).substr(0, data.Value.indexOf('+') - 6), 'x');
			}
			if(key == 'unitid') {
				data.Value = parseInt(data.Value, 10);
			}
			obj[key] = data.Value;
		});
		return obj;
	}
}
